import React, { Component } from 'react';
import { Modal, Table, Checkbox, DatePicker, Input, Spin, Button, Popconfirm, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class EditableCell extends Component {
    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleDateChange = (date, dateString) => {
        this.props.onChange(dateString);
    }
 
    getContent = () => {
        const { type, value, ...rest } = this.props;
        if (type === 'input') {
            return (
                <Input
                    value={value}
                    placeholder='请输入'
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            )
        } else if (type === 'datePicker') {
            return (
                <DatePicker
                    {...rest}
                    placeholder='请选择'
                    style={{ width: '100%' }}
                    value={value ? moment(value) : null}
                    onChange={this.handleDateChange}
                />
            )
        }
    }

    render () {
        const { editable, value } = this.props;
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                    :
                        value
                }
            </div>
        )
    }
}

class TokenActionOrPlan extends Component {
    state = {
        record: {},
        dataSource: [],
        visible: false,
        loading: false,
        hasAdd: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }
    
    hide = () => {
        this.setState({
            dataSource: [],
            visible: false,
            hasAdd: false,
        });
    }

    loadData = () => {
        const { record: { majorEventId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryMajorMeasurePlanByMajorEventId,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                this.setState({
                    hasAdd: false,
                    loading: false,
                    dataSource: list,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleAdd = () => {
        const { dataSource } = this.state;
        dataSource.push({
            editable: true,
        });
        this.setState({
            dataSource,
            hasAdd: true,
        });
    }

    handleUpdate = (index) => {
        const { record, dataSource } = this.state;
        const target = dataSource[index];
        if (!target.editable) {
            target.editable = true;
            this.setState({ dataSource });
        } else {
            const { majorEventId } = record;
            const { measurePlan, planCompletionTimeStr, liableUser } = target;
            if (!measurePlan) {
                message.warning('请输入措施/计划！');
                return;
            } else if (!planCompletionTimeStr) {
                message.warning('请选择计划完成时间！');
                return;
            } else if (!liableUser) {
                message.warning('请输入责任人！');
                return;
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.execute.saveMajorMeasurePlan,
                data: {
                    majorEventId,
                    ...target,
                },
                dataType: 'json',
                doneResult: res => {
                    const { success } = res;
                    message.success(success);
                    this.props.loadData();
                    this.loadData();
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    handleDelete = (index) => {
        const { dataSource } = this.state;
        const { majorMeasurePlanId } = dataSource[index];
        if (!majorMeasurePlanId) {
            dataSource.splice(index, 1);
            this.setState({
                dataSource,
                hasAdd: false,
            });
        } else {
            if (dataSource.length === 1) {
                message.warning('已采取的措施或计划详情不能为空！');
                return;
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.execute.delMajorMeasurePlan,
                data: { majorMeasurePlanId },
                dataType: 'json',
                doneResult: res => {
                    const { success } = res;
                    message.success(success);
                    this.props.loadData();
                    this.loadData();
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    handleChange = (value, key, index) => {
        const dataSource = [...this.state.dataSource];
        const target = dataSource[index];
        target[key] = value;
        this.setState({ dataSource });
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
        return current && current.valueOf() >= value;
    }

    getColumns = () => {
        const { canEdit } = this.props;
        const { record: { canEdit: crcCanEdit } } = this.state;
        const columns = [{
            title: '措施/计划',
            dataIndex: 'measurePlan',
            key: 'measurePlan',
            render: (text, record, index) => {
                const { editable } = record;
                return (
                    <EditableCell
                        editable={editable}
                        type='input'
                        value={text}
                        onChange={value => this.handleChange(value, 'measurePlan', index)}
                    />
                )
            }
        }, {
            title: '计划完成时间',
            dataIndex: 'planCompletionTimeStr',
            key: 'planCompletionTimeStr',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return (
                    <EditableCell
                        editable={editable}
                        type='datePicker'
                        value={text}
                        onChange={value => this.handleChange(value, 'planCompletionTimeStr', index)}
                    />
                )
            }
        }, {
            title: '责任人',
            dataIndex: 'liableUser',
            key: 'liableUser',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return (
                    <EditableCell
                        editable={editable}
                        type='input'
                        value={text}
                        onChange={value => this.handleChange(value, 'liableUser', index)}
                    />
                )
            }
        }, {
            title: '实际完成时间',
            dataIndex: 'actualCompletionTimeStr',
            key: 'actualCompletionTimeStr',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return (
                    <EditableCell
                        editable={editable}
                        type='datePicker'
                        value={text}
                        disabledDate={this.disabledDate}
                        onChange={value => this.handleChange(value, 'actualCompletionTimeStr', index)}
                    />
                )
            }
        }];
        if (canEdit && crcCanEdit) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, record, index) => {
                    const { editable } = record;
                    return (
                        <span>
                            <a onClick={() => this.props.canEditByInvStatus(() => this.handleUpdate(index))}>{editable ? '保存' : '修改'}</a>
                            <span className="ant-divider" />
                            <Popconfirm title="确定删除该记录?" onConfirm={() => this.props.canEditByInvStatus(() => this.handleDelete(index))}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                }
            });
        }
        return columns;
    }

    render() {
        const { loading, visible, record, dataSource, hasAdd } = this.state;
        const { canEdit } = this.props;
        const { canEdit: crcCanEdit, majorEventNumber, investigationName } = record;
        return (
            <Modal
                title="已采取的措施或计划详情"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="700px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading} style={{padding:'20px 20px 10px'}}>
                    <div>
                        重大事件单号：{majorEventNumber}
                        <span className="ant-divider" />
                        项目简称：{investigationName}
                        {
                            (canEdit && crcCanEdit) &&
                            (
                                hasAdd ?
                                    <Button disabled={true} style={{float: 'right', marginLeft: 20}}>添加</Button>
                                :
                                    <Button type="primary" style={{float: 'right', marginLeft: 20}} onClick={() => this.props.canEditByInvStatus(this.handleAdd)}>添加</Button>
                            )
                        }
                    </div>
                    <div style={{margin:'30px 0 20px'}}>
                        <Table  
                            columns={this.getColumns()}
                            dataSource={dataSource}
                            rowKey={record => record.majorMeasurePlanId}
                            pagination={false}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

class EventBelongType extends Component {
    state = {
        checked: [],
        dataSource: [],
    }

    componentDidMount() {
        const { list = [] } = this.props;
        const dataSource = [];
        let idx = 1;
        for (let i = 0; i < list.length; i++) {
            const { childList, optionValue, majorConfigureId } = list[i] || {};
            const childLen = (childList || []).length;
            for (let j = 0; j < childLen; j++) {
                const { majorConfigureId: childMajorConfigureId, optionValue: childOptionValue } = (childList || [])[j];
                dataSource.push({
                    majorConfigureId,
                    childMajorConfigureId,
                    optionValue,
                    index: idx++,
                    childOptionValue,
                    rowSpan: j === 0 ? childLen : 0,
                });
            }
        }
        this.setState({ dataSource });
    }

    componentDidUpdate(prevProps) {
        const { value, visible } = this.props;
        const { dataSource } = this.state;
        if (!prevProps.visible && visible) {
            const checked = [];
            (value || []).forEach(item => {
                const { childMajorConfigureId } = item;
                const idx = dataSource.findIndex(i => i.childMajorConfigureId == childMajorConfigureId);
                if (idx >= 0) {
                    checked.push(idx);
                }
            });
            this.setState({ checked });
        }
    }

    hide = () => {
        this.props.switchDisplay(false);
    }

    handleChange = (e, index) => {
        const { checked } = this.state;
        const value = e.target.checked;
        if (value) {
            checked.push(index);
        } else {
            const idx = checked.findIndex(i => i == index);
            checked.splice(idx, 1);
        }
        this.setState({ checked });
    }

    getColumns = () => [{
        title: '重大事件分类',
        dataIndex: 'optionValue',
        key: 'optionValue',
        width: 120,
        render: (text, record) => {
            const { rowSpan } = record;
            return {
                props: { rowSpan },
                children: text,
            };
        }
    }, {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 80,
    }, {
        title: '细化分类',
        dataIndex: 'childOptionValue',
        key: 'childOptionValue',
    }, {
        title: '归属此类型',
        dataIndex: 'investigationJdeContractId',
        key: 'investigationJdeContractId',
        width: 100,
        render: (text, record, index) => {
            const { checked } = this.state;
            return <Checkbox checked={checked.includes(index)} value={index} onChange={e => this.handleChange(e, index)} />
        }
    }]

    confirm = () => {
        const { checked, dataSource } = this.state;
        const { onChange } = this.props;
        const result = dataSource.filter((item, index) => checked.includes(index));
        onChange(result);
        this.hide();
    }

    render() {
        const { visible } = this.props;
        const { dataSource } = this.state;
        return (
            <Modal
                title="事件归属类型"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                width="800px"
            >
                <div style={{ padding: 10 }}>
                    <Table
                        bordered
                        pagination={false}
                        scroll={{ y: 400 }}
                        dataSource={dataSource}
                        columns={this.getColumns()}
                        rowKey={record => record.childMajorConfigureId}
                    />
                    <div style={{position: 'relative', top: -1, borderBottom: '1px solid #e9e9e9'}} />
                </div>
            </Modal>
        );
    }
}

export { TokenActionOrPlan, EventBelongType };


// WEBPACK FOOTER //
// ./src/components/execute/importantEvent/Widget.js